import { FC, ReactNode } from 'react'
import { ParticipationStatusTag, ParticipationStatusTagType } from './Tag'
import {
  ParticipationStatusOption,
  ParticipationStatusOptionType,
} from './Option'

const ParticipationStatus: FC &
  ParticipationStatusTagType &
  ParticipationStatusOptionType = (): ReactNode => <></>

ParticipationStatus.Tag = ParticipationStatusTag
ParticipationStatus.Option = ParticipationStatusOption

export default ParticipationStatus
